import { Model } from "@rematch/core";
import { ActionPageTypes } from "shared/pages/ActionsPage";

import { IRemoteActionSubState } from "../../model/SharedTypes";
import { StateModules } from "../types";
import { IState } from "./..";
import { postApplicationAction } from "./ActionsEffects";

export interface IActionsModel extends Model {
  name: StateModules;
  state: IActionsState;
  reducers: IActionsReducers;
  effects: IActionsEffects;
}

export type IActionsState = {
  actionType?: ActionPageTypes;
  actionStatus: IRemoteActionSubState<boolean>;
};

export interface IActionParams {
  id: string;
  actionType: ActionPageTypes;
  coworkName?: string;
}

export type IActionsReducers = {
  postingAction: (
    state: IActionsState,
    params: { action: ActionPageTypes }
  ) => IActionsState;
  actionSucceeded: (state: IActionsState) => IActionsState;
  actionFailed: (state: IActionsState, error: string) => IActionsState;
};

export type IActionsEffects = {
  postAction: (params: IActionParams, state: IState) => void;
};

export type IActionsDispatch = {
  postAction: (params: IActionParams) => void;
  postingAction: (params: { action: ActionPageTypes }) => IActionsState;
  actionSucceeded: () => IActionsState;
  actionFailed: (error: string) => IActionsState;
};

export const ActionsModule: IActionsModel = {
  name: "actions",
  state: {
    actionStatus: {
      isPosting: false
    }
  },
  reducers: {
    postingAction: (
      state: IActionsState,
      params: { action: ActionPageTypes }
    ): IActionsState => ({
      ...state,
      actionStatus: {
        isPosting: true,
        error: undefined
      },
      actionType: params.action
    }),
    actionSucceeded: (state: IActionsState): IActionsState => ({
      ...state,
      actionStatus: {
        isPosting: false,
        succeeded: true
      }
    }),
    actionFailed: (state: IActionsState, error: string): IActionsState => ({
      ...state,
      actionStatus: {
        isPosting: false,
        error,
        succeeded: false
      }
    })
  },
  effects: {
    postAction: postApplicationAction
  }
};



// WEBPACK FOOTER //
// ./src/state/modules/actions/ActionsModule.ts